import React, {Component} from 'react';
import Cookies from "universal-cookie";
import {inject, observer} from "mobx-react";

import './News.scss'
import Article from "../../components/article/Article";
import {FETCH_URL} from "../../constants/ServerLinks";
import ArticleThumbnailList from "../../components/article/ArticleThumbnailList";
import TweetList from "../../components/tweet/TweetList";


@observer
class News extends Component {
    constructor(props) {
        super(props);

        this.fetchURL = FETCH_URL;
        this.cookies = new Cookies();
        this.world_id = this.cookies.get('world_id');
        this.config_number = this.cookies.get('config_number');
        this.country_name = this.cookies.get('country_name');
        this.state = {
            tweets: this.props.tweets.tweets,
            articles: this.props.articles.articles
        };
        this.timer = null;
    }

    openArticle = (e, id) => {
        e.preventDefault();

        const dashWrap = document.querySelector('.news__dash__wrap');
        const canvas = document.querySelector('.dash__offCanvas');
        const articleRef = '#' + id;
        const article = document.querySelector(articleRef);
        const articles = document.querySelectorAll('.dash__article');
        //remove all active articles first
        for (let i = 0; i < articles.length; i++) {
            if (articles[i].classList.contains('active-article')) {
                articles[i].classList.remove('active-article');
            }
        }
        article.classList.add('active-article');
        //push canvas left
        canvas.classList.add('canvas-is-open');
        //push main container left
        dashWrap.classList.add('push-left');
        dashWrap.classList.add('overlay-visible');

    };

    closeArticle = () => {

        const dashWrap = document.querySelector('.news__dash__wrap');
        const canvas = document.querySelector('.dash__offCanvas');
        const articles = document.querySelectorAll('.dash__article');
        for (let i = 0; i < articles.length; i++) {
            if (articles[i].classList.contains('active-article')) {
                articles[i].classList.remove('active-article');
            }
        }
        //push canvas left
        canvas.classList.remove('canvas-is-open');
        //push main container left
        dashWrap.classList.remove('push-left');
        dashWrap.classList.remove('overlay-visible');

    };

    fetchNews = () => {
        this.props.articles.fetchArticles([], this.world_id)
            .then(() => {
                // console.log(this.props.articles.articles)
                this.setState({
                    articles: this.props.articles.articles
                })
            });

        this.props.tweets.fetchTweets([], this.world_id)
            .then(() => {
                this.setState({
                    tweets: this.props.tweets.tweets
            })
        });

    };

    componentDidMount() {
        this.timer = setInterval(() => this.fetchNews(), this.props.polTime * 1000);

    };

    componentWillUnmount() {
        this.timer = null;
    }

    render() {
        const {articles, tweets} = this.state;
        const uniqueArticles = Array.from(new Set(articles.map(item => item.title))).map(title => {
            return {
                id: articles.find(el => el.title === title).id,
                source: articles.find(el => el.title === title).source,
                source_icon: articles.find(el => el.title === title).source_icon,
                title: title,
                date: articles.find(el => el.title === title).date,
                excerpt: articles.find(el => el.title === title).excerpt,
                article_img: articles.find(el => el.title === title).article_img,
                content: articles.find(el => el.title === title).content,
                conditional_identifier: articles.find(el => el.title === title).conditional_identifier,
            }
        })
        // console.log(articles)
        // console.log(uniqueArticles)
        return (

            <div className={`${this.props.display === "show" ? "active" : "hidden"}`}>
                    <div className="dash__wrap news__dash__wrap np dash__countryWiki">
                        <div className="overlay"/>
                        <div className="dash__outer flex">
                            <div className="dash__inner dash__twitterFeed">
                                <div className="dash__inner pl4 pb4">
                                    {tweets && tweets.length > 0
                                        ? <TweetList tweets={tweets}/>
                                        : <div className="twitterBg">
                                            <h4 className="align-c t-white pt2">No tweets yet</h4>
                                            <svg className="twitterIcon-bird" viewBox="0 0 1208 982" version="1.1">
                                                <g id="Final-Horizon" stroke="none" strokeWidth="1" fill="none"
                                                   fillRule="evenodd">
                                                    <g id="Artboard" transform="translate(-286.000000, -117.000000)"
                                                       fillRule="nonzero" fill="#1B95E0">
                                                        <path
                                                            d="M1493.75308,233.195911 C1449.31783,252.922544 1401.56126,266.207828 1351.43951,272.19627 C1402.61804,241.549536 1441.92034,192.987798 1460.3889,135.116296 C1412.53168,163.498493 1359.49119,184.130942 1303.02874,195.252335 C1257.88897,147.093181 1193.42514,117 1122.16771,117 C962.190754,117 844.636121,266.258151 880.768067,421.202806 C674.896491,410.886582 492.324484,312.253414 370.089808,162.341063 C305.17308,273.705962 336.423691,419.391176 446.731805,493.16476 C406.171431,491.856361 367.925917,480.734968 334.561738,462.165765 C331.844294,576.95263 414.122472,684.342008 533.287442,708.245454 C498.413572,717.706186 460.218381,719.9204 421.368991,712.47259 C452.871217,810.904465 544.358512,882.514158 652.854997,884.52708 C548.686294,966.201382 417.443793,1002.68559 286,987.186091 C395.653915,1057.48739 525.940278,1098.50067 665.838342,1098.50067 C1125.89162,1098.50067 1385.81015,709.956437 1370.10936,361.469352 C1418.52012,326.494836 1460.53987,282.864756 1493.75308,233.195911 Z"
                                                            id="bird"/>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>}
                                </div>
                            </div>

                            {articles && articles.length > 0
                                ? <div className="dash__inner p4 fg2 relative dash__newsArchive">
                                    <ArticleThumbnailList articleList={uniqueArticles}
                                                          openArticle={this.openArticle}/>
                                </div>
                                : <div className="dash__inner pl4 pb4 relative dash__newsArchive">
                                    <div className="newsBg">
                                        <h4 className="align-c pt2" style={{color: '#242E4A'}}>No news yet</h4>
                                        <svg width="138px" height="182px" viewBox="0 0 138 182" version="1.1">
                                            <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g id="Group-3" fillRule="nonzero" stroke="#242E4A"
                                                   strokeWidth="4.25897036">
                                                    <path
                                                        d="M2.12948518,2.163803 L2.12948518,169.739855 C4.43648536,173.298569 7.05464913,175.778583 9.97790693,177.222602 C13.1071807,178.768388 17.6685586,179.668687 23.5663027,179.870515 L135.00936,179.870515 L135.00936,13.7706708 L111.183199,13.7706708 L111.183199,2.163803 L2.12948518,2.163803 Z"
                                                        id="Rectangle-Copy"/>
                                                    <rect id="Rectangle" stroke="#242E4A" strokeWidth="4.25897036"
                                                          fillRule="nonzero" x="2.12948518" y="2.12948518"
                                                          width="109.313573" height="166.099844"/>
                                                    <g id="Group-2" transform="translate(13.060842, 8.234009)">
                                                        <g id="Group" transform="translate(1.135725, 57.638066)"
                                                           fillRule="nonzero" stroke="#242E4A" strokeWidth="2.83931357">
                                                            <rect id="Rectangle" x="1.41965679" y="1.41965679"
                                                                  width="39.75039" height="35.4914197"/>
                                                            <path d="M50.6817473,79.6427457 L84.7535101,79.6427457"
                                                                  id="Line-Copy-5" strokeLinecap="square"/>
                                                            <path d="M50.6817473,65.4461778 L84.7535101,65.4461778"
                                                                  id="Line-Copy-4" strokeLinecap="square"/>
                                                            <path d="M50.6817473,51.24961 L84.7535101,51.24961"
                                                                  id="Line-Copy-3" strokeLinecap="square"/>
                                                            <path d="M4.11700468,79.2168487 L38.1887676,79.2168487"
                                                                  id="Line-Copy-8" strokeLinecap="square"/>
                                                            <path d="M4.11700468,65.0202808 L38.1887676,65.0202808"
                                                                  id="Line-Copy-7" strokeLinecap="square"/>
                                                            <path d="M4.11700468,50.8237129 L38.1887676,50.8237129"
                                                                  id="Line-Copy-6" strokeLinecap="square"/>
                                                            <path d="M50.6817473,37.0530421 L84.7535101,37.0530421"
                                                                  id="Line-Copy-2" strokeLinecap="square"/>
                                                            <path d="M50.6817473,22.8564743 L84.7535101,22.8564743"
                                                                  id="Line-Copy" strokeLinecap="square"/>
                                                            <path d="M50.6817473,8.6599064 L84.7535101,8.6599064" id="Line"
                                                                  strokeLinecap="square"/>
                                                        </g>

                                                        <text id="NEWS"
                                                              fontFamily="RobotoCondensed-Regular, Roboto Condensed"
                                                              fontSize="35.2074883" fontStyle="condensed"
                                                              fill="#242E4A">
                                                            <tspan x="0" y="33">NEWS</tspan>
                                                        </text>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                </div>}
                        </div>
                    </div>
                    <div className="dash__offCanvas">
                        {articles.map((item, index) => (
                            <Article data={item} key={`article-${index}`} closeArticle={this.closeArticle}/>
                        ))}
                    </div>
                </div>
        )
    }

}

export default inject('articles', 'tweets')(News);
